import { AbstractControl, ValidationErrors } from "@angular/forms";

//  From: https://stackoverflow.com/a/56767071
export const atLeastOneFormFieldRequired = (formGroup: AbstractControl): ValidationErrors | null => {
  return Object.keys(formGroup.value).some(key => !!formGroup.value[key]) ?
    null :
    { atLeastOneRequired : 'Legalább egy mező kitöltése szükséges!' };
}

export const atLeastOneFormFieldRequiredAmong = (fieldsConsidered: string[]) => (formGroup: AbstractControl): ValidationErrors | null => {
  return fieldsConsidered.some(key => !!formGroup.value[key]) ?
    null :
    { atLeastOneRequired : 'Legalább egy mező kitöltése szükséges!' };
}
